import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { AISolutions } from './AISolutions';
import { CodeLanguages } from '../../../../../api/private/global.interface';
import { Container, i18n } from '../../../../../symphony';
import { ResetButton } from '../../../../../shared/public/SlCodeEditorComponents/ResetButton/ResetButton';
import { useContainerData } from '../../../../../shared/public/SlHooks/useContainerData';
import { SlDataService } from '../../../services/sl-data.service';
import { SlEventsService } from '../../../services/Business/sl-events.service';

import s from './RightSide.scss';
import { lePlaygroundContext } from '../../../global-constants';
import { ToggleBtn } from '../../../../../shared/public/SlCodeEditorComponents/ToggleBtn/ToggleBtn';

export interface IHeaderRightSideProps {
	onChangeEditorMode: (state: boolean) => void;
	isDarkMode: boolean;
	language: CodeLanguages;
}

export function HeaderRightSide({
	onChangeEditorMode,
	isDarkMode,
	language,
}: IHeaderRightSideProps): JSX.Element {
	useStyles(s);

	const { isTIYResetButtonActive } = useContainerData(lePlaygroundContext.value, SlDataService, ['isTIYResetButtonActive']);

	const eventService = Container.take(lePlaygroundContext.value, SlEventsService);

	return (
		<div className="sl-header-right-wrapper">
			<ToggleBtn
				state={isDarkMode}
				onChange={onChangeEditorMode}
				title={i18n.t('web-playground.dark-toggle')}
				isDarkMode={isDarkMode}
			/>
			<ResetButton isLightMode={!isDarkMode} className="reset-btn" onClick={eventService.onTIYEditorResetClick} disabled={!isTIYResetButtonActive} />
			{language !== CodeLanguages.SQL && (
				<AISolutions isLightMode={!isDarkMode} isTIYWidget />
			)}
		</div>
	);
}
